import React, { useCallback, useState } from 'react';
import Logo from '../../resources/images/dark-logo.svg';
import { useDispatch } from 'react-redux';
import { IUserCredentials, IUserCredentialsSSO } from '../../../app/resource/user/user.types';
import { logIn } from '../../../app/auth/auth.actions';
import { LoginForm } from './LoginForm';
import { Footer } from './Footer';
import { Dialogs } from '../../dialogs';
import { SignUp } from './SignUp';
import GoogleSSOButton from '../common/sso-buttons/GoogleSSOButton';
import { useApiRequestState } from '../../../utils/api.utils';

export const LoginPage = () => {
  const dispatch = useDispatch();
  const [isLoggingIn] = useApiRequestState('login');

  const [rememberUser, setRememberUser] = useState(false);

  const login = useCallback(
    (data: IUserCredentials | IUserCredentialsSSO) => {
      // Ask the API to open the last workspace the user switched to. Without this,
      // login picks the first active membership. The JWT no longer carries tenant_id.
      const lastTenantSelected = localStorage.getItem('last_tenant_selected');
      let payload = { ...data, rememberUser };
      if (lastTenantSelected) {
        payload = { ...payload, lastTenantSelected };
      }
      dispatch(logIn(payload));
    },
    [dispatch, rememberUser],
  );

  return (
    <>
      <main id="app-root" className="login">
        <div className="fixed-panel">
          <div className="panel w500">
            <div className="panel-body px-5 pb-0">
              <div className="my-5 text-center">
                <img src={Logo} alt="" className="img-fluid" />
              </div>
              <div className="login-form pb-2">
                {isLoggingIn ? (
                  <div className="flex justify-center mb-4">
                    <span className="css-loader" style={{ height: 90, width: 90, borderBottomColor: '#1BC3A7' }}></span>
                  </div>
                ) : (
                  <>
                    <LoginForm onSubmit={login} />
                    <Footer setRememberUser={setRememberUser} />
                    <hr />
                    <GoogleSSOButton onClick={login} />
                    <SignUp />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Dialogs />
    </>
  );
};
